import React, { useState, useEffect, useCallback } from 'react';
import { Select } from 'antd';
import { debounce } from 'lodash';
import { apiGetCategory } from '@services/ManageDevices/DeviceServices';

const { Option } = Select;

const RouteSelect = ({ value, onChange, showTitle = true }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');

  const fetchParentDevices = async (search = '') => {
    setLoading(true);
    try {
      const response = await apiGetCategory({
        keyword: search === '' ? undefined : search,
        type: 'TUYEN'
      });
      setOptions(
        response.data?.data?.map((item) => ({
          label: item.name,
          value: item.value
        }))
      );
    } catch (error) {
      console.error('Error fetching parent device data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Tạo debounced function với useCallback để tránh tạo lại function mỗi lần render
  const debouncedFetchParentDevices = useCallback(
    debounce((searchText) => {
      fetchParentDevices(searchText);
    }, 800),
    []
  );

  useEffect(() => {
    fetchParentDevices();
  }, []);

  const handleChange = (values) => {
    onChange(values);
    // Clear search text after selection
    if (searchText) {
      setSearchText('');
      fetchParentDevices();
    }
    // Load all data again (without search filter)
  };

  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
    debouncedFetchParentDevices(searchValue);
  };

  return (
    <div style={{ marginBottom: '16px' }}>
      {showTitle && (
        <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
          Mạng lưới
        </label>
      )}
      <Select
        mode="multiple"
        value={value || []}
        onChange={handleChange}
        placeholder="Chọn Mạng lưới"
        style={{ width: '100%', height: '36px' }}
        showSearch
        filterOption={false}
        onSearch={handleSearch}
        searchValue={searchText}
        loading={loading}
        allowClear
        maxTagCount="responsive"
        // disabled={!parentManageGroup || parentManageGroup.length === 0}
      >
        {options.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default RouteSelect;
